import { render, staticRenderFns } from "./ReorderIcon.vue?vue&type=template&id=3d268857"
import script from "./ReorderIcon.vue?vue&type=script&lang=js"
export * from "./ReorderIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports